import * as yup from 'yup';
import { FormParam } from '@repositories/new-application/models';

export const defaultValues: FormParam<'financial'> = {
  monthlyIncome: '',
  bankName: '',
  bankAccountNumber: '',
  loanPurpose: '',
  referralCode: '',
  bankAccountNumberVerified: false,
};

const schemes: Record<keyof FormParam<'financial'>, unknown> = {
  monthlyIncome: yup.string().test(function (value) {
    if (typeof value === 'undefined' || value === '') {
      return this.createError({
        path: this.path,
        message: 'Kolom wajib diisi',
      });
    }

    if (value.length > 100) {
      return this.createError({
        path: this.path,
        message: 'Maksimal 100 karakter',
      });
    }

    return true;
  }),
  bankName: yup.string().required('Kolom wajib diisi'),
  bankAccountNumber: yup
    .string()
    .required('Kolom wajib diisi')
    .test(function (value) {
      if (value.length > 100) {
        return this.createError({
          path: this.path,
          message: 'Maksimal 100 karakter',
        });
      }

      const bankAccountField = document.querySelector(
        'input[data-bank-account-invalid]',
      );

      if (!bankAccountField) return true;

      const errorMessage = bankAccountField.getAttribute(
        'data-bank-account-error-message',
      );
      const isInvalid =
        bankAccountField.getAttribute('data-bank-account-invalid') === 'true';
      const isVerified =
        bankAccountField.getAttribute('data-bank-account-verified') === 'true';

      if (isVerified) return true;
      if (isInvalid)
        return this.createError({
          path: this.path,
          message: errorMessage || 'Nomor rekening tidak terdaftar',
        });

      return true;
    }),
  loanPurpose: yup.string().required('Kolom wajib diisi'),
  referralCode: yup.string().test(function (value = '') {
    if (value?.length > 100) {
      return this.createError({
        path: this.path,
        message: 'Maksimal 100 karakter',
      });
    }

    return true;
  }),
  bankAccountNumberVerified: yup.bool(),
};

export const financialSchema = yup.object<FormParam<'financial'>>(schemes);
